import axios from "axios";
import store from "@/store"
import { localStorageKeys } from "@/enums/common";
const Constants = {
  install(Vue) {
    Vue.prototype.$constants = (key) => {


      const constantList = {
        $http: axios.create({
          baseURL: store.getters['common/getApiBaseUrl'],
        }),
        axios: axios.create({
          baseURL: store.getters['common/getServerlessApiBaseUrl'],
        }),
      }

      const jwt = store.getters['common/getLocalStorageValueByKey'](localStorageKeys.jwt);

      if (jwt) {
        constantList.axios.defaults.headers.Authorization = jwt
        constantList.$http.defaults.headers.Authorization = jwt
      }

      constantList.$http.interceptors.request.use(config => {

        return {
          ...config,
          cancelToken: store.getters['common/getAxiosCancelToken'].v1.token
        };

      });


      constantList.$http.interceptors.response.use(response => {

        return response;

      }, error => {

        if (error.hasOwnProperty('toJSON') && error.toJSON().message == 'Network Error') return;

        return Promise.reject(error);

      });


      constantList.axios.interceptors.request.use(config => {

        return {
          ...config,
          cancelToken: store.getters['common/getAxiosCancelToken'].v2.token
        };

      });

      constantList.axios.interceptors.response.use(response => {

        return response;

      }, error => {

        if (error.hasOwnProperty('toJSON') && error.toJSON().message == 'Network Error') return;

        return Promise.reject(error);

      });


      return constantList[key];
    }
  }
}

export default Constants;




// WEBPACK FOOTER //
// ./src/plugins/constants.js